'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _reactUtils = require('react-utils');

var _reactRedux = require('react-redux');

var _Raven = require('Raven');

var _Raven2 = _interopRequireDefault(_Raven);

var _UILoading = require('UIComponents/loading/UILoading');

var _UILoading2 = _interopRequireDefault(_UILoading);

var _BookingContainer = require('MeetingsLib/components/page/BookingContainer');

var _BookingContainer2 = _interopRequireDefault(_BookingContainer);

var _BookingSummary = require('MeetingsLib/components/page/BookingSummary');

var _BookingSummary2 = _interopRequireDefault(_BookingSummary);

var _Error = require('MeetingsLib/components/Error');

var _Error2 = _interopRequireDefault(_Error);

var _utils = require('MeetingsLib/utils/utils');

var _analytics = require('MeetingsLib/utils/analytics');

var _UsageTracker = require('MeetingsLib/tracking/UsageTracker');

var _NetworkErrorSelector = require('MeetingsLib/selectors/NetworkErrorSelector');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _FormActions = require('MeetingsLib/redux/actions/FormActions');

var FormActions = _interopRequireWildcard(_FormActions);

var _BookActions = require('MeetingsLib/redux/actions/BookActions');

var BookActions = _interopRequireWildcard(_BookActions);

var _UIActions = require('MeetingsLib/redux/actions/UIActions');

var UIActions = _interopRequireWildcard(_UIActions);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _DisplayInfo = require('MeetingsBase/models/DisplayInfo');

var _DisplayInfo2 = _interopRequireDefault(_DisplayInfo);

var _UserMessage = require('MeetingsLib/models/UserMessage');

var _UserMessage2 = _interopRequireDefault(_UserMessage);

var _BookingLifecycle = require('MeetingsLib/models/BookingLifecycle');

var _BookingLifecycle2 = _interopRequireDefault(_BookingLifecycle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = _react2.default.createClass({
  displayName: 'App',

  propTypes: {
    // passable props
    branding: _react.PropTypes.instanceOf(_Branding2.default).isRequired,
    displayInfo: _react.PropTypes.instanceOf(_DisplayInfo2.default).isRequired,
    hideLogo: _react.PropTypes.bool,

    // props from store (don't change these)
    bookInfoErrorText: _react.PropTypes.string,
    bookingLifecycle: _react.PropTypes.instanceOf(_BookingLifecycle2.default).isRequired,
    companyName: _react.PropTypes.string,
    embedded: _react.PropTypes.bool.isRequired,
    isInvalidDomainError: _react.PropTypes.bool,
    isSalesStarter: _react.PropTypes.bool,
    offline: _react.PropTypes.bool,
    onSuccess: _react.PropTypes.func,
    parentPageHSAnalyticsInfo: _react.PropTypes.instanceOf(Object),
    portalId: _react.PropTypes.number.isRequired,
    profile: _react.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    userMessage: _react.PropTypes.instanceOf(_UserMessage2.default),
    userTimezone: _react.PropTypes.string,

    // action dispatchers
    getUserProfile: _react.PropTypes.func.isRequired,

    // request statuses
    bookingPageLoading: _react.PropTypes.bool.isRequired,
    submittingMeeting: _react.PropTypes.bool.isRequired,
    shouldRenderBookingPage: _react.PropTypes.bool.isRequired,
    meetingCreationSuccess: _react.PropTypes.bool.isRequired,
    fetchBookInfoFailed: _react.PropTypes.bool.isRequired,
    meetingCreationFailed: _react.PropTypes.bool.isRequired,
    availabilityFetchFailed: _react.PropTypes.bool.isRequired,
    userProfileLoadSuccess: _react.PropTypes.bool.isRequired,
    availabilityFetchSuccess: _react.PropTypes.bool.isRequired,
    initTrackingForMeetings: _react.PropTypes.bool.isRequired
  },

  componentWillMount: function componentWillMount() {
    var getUserProfile = this.props.getUserProfile;


    getUserProfile();
    (0, _analytics.trackLibVersionInNewRelic)();
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var _props = this.props,
        previousFormGuid = _props.formGuid,
        initTrackingForMeetings = _props.initTrackingForMeetings;
    var profile = nextProps.profile,
        headline = nextProps.displayInfo.headline,
        availabilityFetchSuccess = nextProps.availabilityFetchSuccess,
        userProfileLoadSuccess = nextProps.userProfileLoadSuccess,
        portalId = nextProps.portalId,
        linkType = nextProps.linkType,
        nextFormGuid = nextProps.formGuid,
        nextContentTracking = nextProps.contentTracking,
        embedded = nextProps.embedded,
        companyName = nextProps.companyName;


    var profileLoaded = userProfileLoadSuccess && userProfileLoadSuccess !== this.props.userProfileLoadSuccess;

    if (profileLoaded && initTrackingForMeetings) {
      (0, _UsageTracker.initializeMeetingsLibTracker)(nextProps.profile.email, portalId, embedded);
      (0, _UsageTracker.track)('meetingsLibLoaded');
    }

    var shouldSetDocumentTitle = this.shouldSetDocumentTitle(availabilityFetchSuccess, userProfileLoadSuccess, embedded);
    if (shouldSetDocumentTitle) {
      (0, _utils.setDocumentTitle)(headline, linkType, companyName, profile);
    }

    var shouldTrackFormViews = this.shouldTrackFormViews(previousFormGuid, nextFormGuid);
    if (shouldTrackFormViews && userProfileLoadSuccess) {
      (0, _analytics.trackHsFormViews)(nextFormGuid, portalId, _extends({}, this.props.parentPageHSAnalyticsInfo, nextContentTracking), embedded);
      (0, _analytics.addHsTrackingCode)(portalId, embedded);
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var availabilityFetchDidFail = prevProps.availabilityFetchFailed,
        previousBookingStep = prevProps.bookingLifecycle;
    var _props2 = this.props,
        availabilityFetchFailed = _props2.availabilityFetchFailed,
        meetingCreationSuccess = _props2.meetingCreationSuccess,
        bookInfoErrorText = _props2.bookInfoErrorText,
        onSuccess = _props2.onSuccess,
        currentBookingStep = _props2.bookingLifecycle;


    if (meetingCreationSuccess) {
      parent.postMessage({ meetingBookSucceeded: true }, '*');

      var meetingCreationPreviouslySucceeded = previousBookingStep.get('postResponse') !== null;
      var meetingCreationJustSucceeded = currentBookingStep.get('postResponse') !== null;

      if (onSuccess && !meetingCreationPreviouslySucceeded && meetingCreationJustSucceeded) {
        var bookingSuccessInformation = (0, _toJS2.default)(currentBookingStep.get('postResponse'));
        onSuccess(bookingSuccessInformation);
      }
    }

    if (!availabilityFetchDidFail && availabilityFetchFailed) {
      (0, _UsageTracker.track)('meetingsLibViewScreen', { subscreen: 'generic error page' });
      _Raven2.default.captureBreadcrumb({
        message: 'Public availability info fetch failed!',
        data: {
          error: bookInfoErrorText
        }
      });
    }
  },
  shouldSetDocumentTitle: function shouldSetDocumentTitle(availabilityFetchSuccess, userProfileLoadSuccess, embedded) {
    var meetingsLinkExists = availabilityFetchSuccess && userProfileLoadSuccess;

    return !embedded && meetingsLinkExists;
  },
  shouldTrackFormViews: function shouldTrackFormViews(previousFormGuid, nextFormGuid) {
    return previousFormGuid !== nextFormGuid;
  },
  renderBookingContainer: function renderBookingContainer() {
    var _props3 = this.props,
        branding = _props3.branding,
        hideLogo = _props3.hideLogo,
        profile = _props3.profile,
        submittingMeeting = _props3.submittingMeeting,
        _props3$displayInfo = _props3.displayInfo,
        avatar = _props3$displayInfo.avatar,
        headline = _props3$displayInfo.headline;


    return _react2.default.createElement(_BookingContainer2.default, {
      avatar: avatar,
      branding: branding,
      headline: headline,
      hideLogo: hideLogo,
      profile: profile,
      submittingMeeting: submittingMeeting
    });
  },
  renderSummary: function renderSummary() {
    var _props4 = this.props,
        bookingLifecycle = _props4.bookingLifecycle,
        branding = _props4.branding,
        _props4$displayInfo = _props4.displayInfo,
        avatar = _props4$displayInfo.avatar,
        headline = _props4$displayInfo.headline,
        embedded = _props4.embedded,
        isSalesStarter = _props4.isSalesStarter,
        offline = _props4.offline,
        profile = _props4.profile,
        userTimezone = _props4.userTimezone;


    var bookedDateTime = bookingLifecycle.postResponse.get('timerange').start;

    return _react2.default.createElement(_BookingSummary2.default, {
      avatar: avatar,
      bookedDateTime: bookedDateTime,
      branding: branding,
      embedded: embedded,
      headline: headline,
      isSalesStarter: isSalesStarter,
      offline: offline,
      profile: profile,
      userTimezone: userTimezone
    });
  },
  renderError: function renderError(profile) {
    var _props5 = this.props,
        fetchBookInfoFailed = _props5.fetchBookInfoFailed,
        isSalesStarter = _props5.isSalesStarter,
        meetingCreationFailed = _props5.meetingCreationFailed,
        userProfileLoadSuccess = _props5.userProfileLoadSuccess,
        isInvalidDomainError = _props5.isInvalidDomainError;


    return _react2.default.createElement(_Error2.default, {
      profile: profile,
      isSalesStarter: isSalesStarter,
      isInvalidDomainError: isInvalidDomainError,
      meetingCreationFailed: meetingCreationFailed,
      bookInfoFailed: fetchBookInfoFailed,
      userProfileLoadSuccess: userProfileLoadSuccess
    });
  },
  renderApplication: function renderApplication() {
    var _props6 = this.props,
        profile = _props6.profile,
        bookingPageLoading = _props6.bookingPageLoading,
        shouldRenderBookingPage = _props6.shouldRenderBookingPage,
        meetingCreationSuccess = _props6.meetingCreationSuccess,
        availabilityFetchFailed = _props6.availabilityFetchFailed,
        embedded = _props6.embedded,
        isSalesStarter = _props6.isSalesStarter;

    // protect from sneaky uses of paid embed functionality
    // by free or downgraded users

    var isUnpaidEmbed = embedded && !isSalesStarter;

    if (shouldRenderBookingPage && !availabilityFetchFailed && !isUnpaidEmbed) {
      return this.renderBookingContainer();
    }

    if (bookingPageLoading) {
      return _react2.default.createElement(_UILoading2.default, { use: 'primary-orange' });
    }

    if (meetingCreationSuccess) {
      return this.renderSummary();
    }

    return this.renderError(profile);
  },
  render: function render() {
    var embedded = this.props.embedded;


    var className = (0, _reactUtils.classNames)('meetings-lib', { embedded: embedded });

    return _react2.default.createElement(
      'div',
      { className: className },
      this.renderApplication()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state, props) {
  return {
    linkType: (0, _BookInfoSelectors.getBookInfo)(state).linkType,
    formGuid: (0, _BookInfoSelectors.getBookInfo)(state).formGuid,
    contentTracking: (0, _BookInfoSelectors.getBookInfo)(state).contentTracking,
    offline: (0, _BookInfoSelectors.getBookInfo)(state).offline,
    branding: props.branding || state.branding,
    portalId: state.portalId,
    profile: (0, _BookInfoSelectors.getUserProfile)(state, props),
    companyName: state.companyName,
    bookingLifecycle: state.bookingLifecycle,
    currentTime: state.currentTime,
    userMessage: state.userMessage,
    userTimezone: state.userTimezone,
    bookInfoErrorText: (0, _NetworkErrorSelector.getBookInfoErrorText)(state),
    isInvalidDomainError: (0, _NetworkErrorSelector.isInvalidDomainError)(state),
    initTrackingForMeetings: state.initTrackingForMeetings,
    onSuccess: state.onSuccess,
    embedded: state.embedded,
    displayInfo: (0, _BookInfoSelectors.getDisplayInfo)(state, props),
    isSalesStarter: state.isSalesStarter,
    parentPageHSAnalyticsInfo: state.parentPageHSAnalyticsInfo,
    // request statuses
    meetingCreationSuccess: (0, _RequestStatusSelectors.meetingCreationSuccess)(state),
    bookingPageLoading: (0, _RequestStatusSelectors.bookingPageLoading)(state),
    shouldRenderBookingPage: (0, _RequestStatusSelectors.shouldRenderBookingPage)(state),
    fetchBookInfoFailed: (0, _RequestStatusSelectors.fetchBookInfoFailed)(state),
    meetingCreationFailed: (0, _RequestStatusSelectors.meetingCreationFailed)(state),
    availabilityFetchFailed: (0, _RequestStatusSelectors.availabilityFetchFailed)(state),
    userProfileLoadSuccess: (0, _RequestStatusSelectors.userProfileLoadSuccess)(state),
    availabilityFetchSuccess: (0, _RequestStatusSelectors.availabilityFetchSuccess)(state),
    submittingMeeting: (0, _RequestStatusSelectors.isSubmittingMeeting)(state)
  };
}, _extends({}, FormActions, BookActions, UIActions))(App);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/AppContainer.js
// module id = 283
// module chunks = 0